import { Controller } from "@hotwired/stimulus"

// _complete_body の「ご希望の連絡日時」checkbox group → submit button 有効化を扱う
// controller (#1833 PR 7)。
//
// 旧 _complete_body には既に `data-controller="preferred-contact-times"` / `data-action`
// 参照が記述されていたが、対応 controller が未実装で **dead reference 状態** だった。
// 実 logic は同 view の inline <script> が turbo:load 経由で動かしていた pattern。
// 本 PR で controller を実装 + 既存 dead ref を正しく namespaced に修正 + inline script
// を撤廃して結合。
//
// scope: form を wrap する div に置く (form 内の checkbox 全部 + submit button を 1 scope
// で扱える)。`data-controller` を submit button 1 要素だけに付けていた旧 view は scope
// が button にしか効かず checkbox change を捕捉できないため、wrapper に格上げ。
//
// XSS 安全性: classList / disabled の操作のみ、innerHTML 不使用。
//
// Rule of Three: 1 view 専用、class 名は旧 inline JS と parity 維持で hardcoded。
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.update()
  }

  update() {
    const anyChecked = this.checkboxTargets.some((cb) => cb.checked)
    if (anyChecked) {
      this.submitTarget.disabled = false
      this.submitTarget.classList.remove("bg-[#CACACA]")
      this.submitTarget.classList.add("bg-[#dc2626]", "hover:bg-[#b91c1c]")
    } else {
      this.submitTarget.disabled = true
      this.submitTarget.classList.remove("bg-[#dc2626]", "hover:bg-[#b91c1c]")
      this.submitTarget.classList.add("bg-[#CACACA]")
    }
  }
}
